const PROVIDER_LABELS = { google: "Google", microsoft: "Microsoft" };

export const NO_RESPONSIBLE_FILTER = "none";

export const EMPTY_MAIL_ACCOUNT_FILTERS = {
  query: "",
  accountId: "",
  responsibleId: "",
};

export function describeMailAccountConnection(mailAccount) {
  const providerType = mailAccount?.oauth_account?.provider_type;
  if (providerType) {
    const providerLabel = PROVIDER_LABELS[providerType] ?? providerType;
    if (mailAccount.oauth_account.needs_reauth) {
      return { label: `${providerLabel} · reautorizar`, warning: true };
    }
    return { label: providerLabel, warning: false };
  }
  if (mailAccount?.smtp) return { label: "SMTP", warning: false };
  return { label: "Sin conexión", warning: true };
}

export function assignmentDisplayName(assignment) {
  return assignment?.full_name || assignment?.username || assignment?.email || "-";
}

export function userDisplayName(user) {
  const fullName = `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
  return fullName || user?.username || user?.email || "-";
}

export function mailAccountTitle(mailAccount) {
  return mailAccount?.name || mailAccount?.email || "-";
}

export function buildResponsibleOptions(mailAccounts) {
  const byUserId = new Map();
  (mailAccounts ?? []).forEach((mailAccount) => {
    (mailAccount.users ?? []).forEach((assignment) => {
      if (assignment?.user_id == null || byUserId.has(assignment.user_id)) return;
      byUserId.set(assignment.user_id, {
        id: assignment.user_id,
        name: assignmentDisplayName(assignment),
        email: assignment.email ?? "",
      });
    });
  });
  return Array.from(byUserId.values()).sort((firstUser, secondUser) =>
    firstUser.name.localeCompare(secondUser.name, "es", { sensitivity: "base" }),
  );
}

function matchesQuery(mailAccount, normalizedQuery) {
  if (!normalizedQuery) return true;
  const haystack = [
    mailAccount.name,
    mailAccount.email,
    mailAccount.account_name,
    ...(mailAccount.users ?? []).flatMap((assignment) => [
      assignment.full_name,
      assignment.username,
      assignment.email,
    ]),
  ];
  return haystack.some((value) => (value ?? "").toString().toLowerCase().includes(normalizedQuery));
}

function matchesResponsible(mailAccount, responsibleId) {
  if (!responsibleId) return true;
  const assignments = mailAccount.users ?? [];
  if (responsibleId === NO_RESPONSIBLE_FILTER) return assignments.length === 0;
  return assignments.some((assignment) => String(assignment.user_id) === String(responsibleId));
}

export function filterMailAccounts(mailAccounts, filters = EMPTY_MAIL_ACCOUNT_FILTERS) {
  const normalizedQuery = (filters.query ?? "").trim().toLowerCase();
  return (mailAccounts ?? []).filter((mailAccount) => {
    if (filters.accountId && String(mailAccount.account) !== String(filters.accountId)) return false;
    if (!matchesResponsible(mailAccount, filters.responsibleId)) return false;
    return matchesQuery(mailAccount, normalizedQuery);
  });
}

export function hasActiveMailAccountFilters(filters) {
  return Boolean((filters.query ?? "").trim() || filters.accountId || filters.responsibleId);
}
